import { render } from "./InvoiceScans.vue?vue&type=template&id=11430333&scoped=true&ts=true"
import script from "./InvoiceScans.vue?vue&type=script&lang=ts"
export * from "./InvoiceScans.vue?vue&type=script&lang=ts"

import "./InvoiceScans.vue?vue&type=style&index=0&id=11430333&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11430333"]])

export default __exports__